const getApiBaseURL = () => {
  // Get current environment info
  const hostname = window.location.hostname;
  const nodeEnv = process.env.NODE_ENV;
  const envApiUrl = process.env.REACT_APP_API_BASE_URL?.trim();

  // Log for debugging
  console.log("🔍 API Base URL Detection:", {
    hostname,
    nodeEnv,
    envApiUrl,
  });

  // Local development
  if (hostname === "localhost" || hostname === "127.0.0.1") {
    console.log("✅ Using local development URL");
    return "http://localhost:5000";
  }

  // If environment variable is set, use it (highest priority)
  if (envApiUrl) {
    console.log("✅ Using environment variable URL:", envApiUrl);
    return envApiUrl;
  }

  // 🔧 STAGING ENVIRONMENT - KNOWN TO WORK
  if (hostname === "stg.webvenly.com" || hostname.includes("stg")) {
    console.log("✅ Using staging URL (auto-detected)");
    return "https://webvenly-backend-staging-823753138069.us-east1.run.app";
  }

  // 🔧 TRN (TRAINING) ENVIRONMENT - NEW ADDITION
  if (hostname === "trn.webvenly.com" || hostname.includes("trn")) {
    console.log("✅ Using TRN URL (auto-detected)");
    return "https://webvenly-backend-trn-823753138069.us-east1.run.app";
  }

  // 🔧 DEV ENVIRONMENT (if needed)
  if (hostname === "dev.webvenly.com" || hostname.includes("dev")) {
    console.log("✅ Using dev URL (auto-detected)");
    return "https://webvenly-backend-dev-823753138069.us-east1.run.app";
  }

  // 🔧 PRODUCTION ENVIRONMENT
  if (hostname === "prd.webvenly.com" || hostname.includes("prd")) {
    console.log("✅ Using production URL (auto-detected)");
    return "https://webvenly-backend-prd-823753138069.us-east1.run.app";
  }

  // 🚨 CRITICAL: No API URL could be determined
  console.error(
    "❌ CRITICAL: REACT_APP_API_BASE_URL environment variable not set!"
  );
  console.error("🌐 Current hostname:", hostname);
  console.error("📋 Configure REACT_APP_API_BASE_URL in your deployment");
  console.error("🔍 Supported hostnames:");
  console.error("   - stg.webvenly.com (staging)");
  console.error("   - trn.webvenly.com (training)");
  console.error("   - dev.webvenly.com (development)");
  console.error("   - prd.webvenly.com (production)");

  throw new Error(
    `API URL not configured for hostname: ${hostname}. Set REACT_APP_API_BASE_URL environment variable.`
  );
};

export default getApiBaseURL;
